import StyledTextLink from '@/atoms/Links/Text/styles';
import colors from '@/theme/constants/colors';
import pxToRem from '@/theme/helpers/pxToRem';
import typography from '@/theme/typography';
import styled from 'styled-components';

export const StyledReturnPolicyLink = styled.div`
  ${typography.Subtitle1}
  background: ${colors.white};
  border-radius: 10px;
  margin: ${pxToRem(5)} 0;
  padding: ${pxToRem(5)};
  display: grid;
  grid-template-columns: 50px 1fr;
  grid-template-rows: 25px 1fr;
  color: ${colors.darkBlue100};

  img {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
    justify-self: start;
    align-self: center;
  }

  > p {
    grid-column: 2 / span 1;
    grid-row: 2 / span 1;
    ${typography.Body2}

    >span {
      display: inline-block;
      margin-right: ${pxToRem(5)};
    }
  }

  ${StyledTextLink} {
    white-space: nowrap;
  }
`;
